import { Card } from 'react-bootstrap';
import { useSettings } from 'Settings';
import ValueTransform from 'ValueTransform';

const round = (num) => {
	const n = num.toString();
	const i = n.indexOf('.');
	
	if (i === -1) {
		return num;
	} else {
		return +n.substr(0, i + 3);
	}
}

const SimulationValue = ({name, value}) => {
	return (
		<Card className='mb-3'>
			<Card.Body className="d-flex justify-content-between">
				<span>{name}</span>
				<span>{value}</span>
			</Card.Body>
		</Card>
	)
}


const Simulation = () => {

	const [settings] = useSettings();
	const { timing } = settings;
	const sl = settings['supervisory level'];
	const { t_hrv_meas, t_hrv_period, t_sts_period, t_lts_period } = timing;
	const { v_bat_max_hi, v_lvl_acc } = sl;

	const bat_max_hi = ValueTransform(v_bat_max_hi.value, v_lvl_acc.value);

	const efficiency_loss = round(t_hrv_meas.value / t_hrv_period.value * 100 * bat_max_hi / 1.8)

	const consuption_internal_dev = round(234 * bat_max_hi / 1.8)
	const ulp_ldo = round(59.4 * bat_max_hi / 1.8)
	const vaux_ldo = round(216 * bat_max_hi / 1.8)
	const hrv = round(3000 / (8 * t_hrv_period.value) * bat_max_hi / 1.8)
	const sts = round(3000 / (4 * t_sts_period.value) * bat_max_hi / 1.8)
	const lts = round(3000 / (4 * t_lts_period.value) * bat_max_hi / 1.8)

	const sum = round((consuption_internal_dev + ulp_ldo + vaux_ldo + hrv + sts + lts) / 1000)

	return (
		<div className="container">
			<h1>Simulation</h1>
					<SimulationValue name="Efficiency Loss" value={`${efficiency_loss}%`} />
			<Card>
				<Card.Header className="d-flex align-items-center">
					<Card.Title>Internal Consumption</Card.Title>
					<span className="ms-auto">{`${sum} `}&mu;W</span>
				</Card.Header>
				<Card.Body>
					<SimulationValue name="Consumption of HRV measurement" value={`${hrv} nW`} />
					<SimulationValue name="Consumption to supervise STS" value={`${sts} nW`} />
					<SimulationValue name="Consumption to supervise LTS" value={`${lts} nW`} />
					<SimulationValue name="Consumption of internal oscilator, internal regulator, internal power management, POR etc." value={`${consuption_internal_dev} nW`} />
					<SimulationValue name="Consumption of ULP LDO" value={`${ulp_ldo} nW`} />
					<SimulationValue name="Consumption of VAUX LDO" value={`${vaux_ldo} nW`} />
				</Card.Body>
			</Card>
		</div>
	)
}

export default Simulation
